export default {
  id: "vault",
  name: "The Vault",
  shortName: "Vault",
  description: "Your social media content library: photos and videos",
  icon: "folder",
  color: "#8963BA",
  roles: ["super_admin", "admin", "corporate", "marketing_agency", "franchisee"],
  css: "styles/apps/vault.css?v=8",
  // Navigation lives in the Vault sidebar (Home / Recent / Folders / Tags).
  // No top-bar nav — keeps Vault consistent with Settings and the other
  // sidebar-driven apps.
  nav: [],
  defaultView: "browse",
};
